export class UnreachableError extends Error {
  constructor(x: never) {
    super(`Unreachable type error: ${x}`);
  }
}
